{
  "sdk-download-android": "ດາວໂຫຼດສໍາລັບ Android",
  "sdk-connect": "ເຊື່ອມຕໍ່",
  "sdk-download-ios": "ດາວໂຫຼດສໍາລັບ iOS",
  "sdk-install": "ຕິດຕັ້ງ",
  "sdk-modal-instruct-1": "1. ເປີດແອັບ Binance",
  "sdk-modal-instruct-2": "2. ແຕະ {{icon}} ໃນໜ້າຈໍຫຼັກ",
  "sdk-modal-title": "ເຊື່ອມຕໍ່ກັບ Binance",
  "sdk-no-app": "ຍັງບໍ່ມີແອັບ Binance ເທື່ອບໍ?"
}